var COLORS=[
  {name:"Beige", hex:"#E4D5C0", img:MPASSET["mp-beige.png"]},
  {name:"Pink",  hex:"#E0B3B0", img:MPASSET["mp-pink.png"]},
  {name:"Grey",  hex:"#A9A5A0", img:MPASSET["mp-grey.png"]},
  {name:"Khaki", hex:"#A6A98F", img:MPASSET["mp-khaki.png"]},
  {name:"Coffee",hex:"#7A5B46", img:MPASSET["mp-coffee.png"]},
  {name:"Black", hex:"#282524", img:MPASSET["mp-black.png"]}
];
var SIZES=["S","M","L","XL","2XL"];
var TIERS={
  1:{price:59.95, was:99.90,  gifts:0, giftVal:0,  img:MPASSET["mp-gift2.png"]},
  2:{price:109.90,was:199.80, gifts:2, giftVal:23, img:MPASSET["mp-gift2.png"]},
  3:{price:154.85,was:299.70, gifts:4, giftVal:45, img:MPASSET["mp-gift4.png"]}
};
var GIFTS=[
  {n:"Catnip Kicker Fish", v:12, i:MPASSET["mp-g1.png"]},
  {n:"Feather Teaser Wand", v:11, i:MPASSET["mp-g2.png"]},
  {n:"Silicone Grooming Glove", v:13, i:MPASSET["mp-g3.png"]},
  {n:"Crinkle Ball 4-Pack", v:9, i:MPASSET["mp-g4.png"]}
];
var SHIP_PROT=9.99, FREE_SHIP=60, UNIT_RRP=99.90;
var state={color:"Beige", size:"M", tier:2, ship:true, cart:[], popDone:false};
function money(n){return "$"+n.toFixed(2)}

/* payment marks */
document.getElementById('payRow').innerHTML=[
 '<span class="pay" title="Visa"><span class="pay-t" style="color:#1A1F71;font-style:italic">VISA</span></span>',
 '<span class="pay" title="Mastercard"><svg width="28" height="17" viewBox="0 0 30 18"><circle cx="11.5" cy="9" r="6.2" fill="#EB001B"/><circle cx="18.5" cy="9" r="6.2" fill="#F79E1B"/><path d="M15 4.1a6.2 6.2 0 0 0 0 9.8 6.2 6.2 0 0 0 0-9.8z" fill="#FF5F00"/></svg></span>',
 '<span class="pay" title="American Express" style="background:#006FCF;border-color:#006FCF"><span class="pay-t" style="color:#fff;font-size:8.5px">AMEX</span></span>',
 '<span class="pay" title="PayPal"><span class="pay-t" style="font-style:italic"><span style="color:#003087">Pay</span><span style="color:#009CDE">Pal</span></span></span>',
 '<span class="pay" title="Shop Pay" style="background:#5A31F4;border-color:#5A31F4"><span class="pay-t" style="color:#fff;font-size:9.5px">shop</span></span>',
 '<span class="pay" title="Apple Pay"><svg width="28" height="15" viewBox="0 0 30 15"><path d="M8.6 4.3c-.4.5-1.1.9-1.7.8-.1-.7.2-1.4.6-1.8.4-.5 1.1-.8 1.7-.9.1.7-.2 1.4-.6 1.9zm.6 1c-1-.1-1.8.5-2.2.5-.5 0-1.2-.5-1.9-.5-1 0-1.9.6-2.4 1.5-1 1.7-.3 4.3.7 5.7.5.7 1.1 1.5 1.8 1.4.7 0 1-.4 1.9-.4s1.1.4 1.9.4c.8 0 1.3-.7 1.8-1.4.6-.8.8-1.6.8-1.6s-1.5-.6-1.6-2.3c0-1.4 1.2-2.1 1.2-2.2-.6-1-1.7-1.1-2-1.1z" fill="#000"/><text x="13" y="11" font-family="Karla,sans-serif" font-size="8.5" font-weight="700" fill="#000">Pay</text></svg></span>'
].join('');

/* gallery */
function buildThumbs(){
  var extra=[{name:"Small dogs too",img:MPASSET["mp-d1.png"]},{name:"Pouch detail",img:MPASSET["mp-detail.png"]},
             {name:"Empty pouch",img:MPASSET["mp-empty2.png"]},{name:"Worn at home",img:MPASSET["mp-evening.png"]},
             {name:"Dog at home",img:MPASSET["mp-d2.png"]},{name:"Customer photo",img:MPASSET["mp-u3.png"]}];
  var t=document.getElementById('gThumbs'); t.innerHTML='';
  COLORS.concat(extra).forEach(function(c,i){
    var b=document.createElement('button');
    b.setAttribute('aria-current', i===0?'true':'false');
    b.setAttribute('aria-label', c.name);
    b.innerHTML='<img src="'+c.img+'" alt="'+c.name+'" loading="lazy">';
    b.onclick=function(){ showImg(c.img,c.name) };
    t.appendChild(b);
  });
}
function showImg(src,label){
  document.getElementById('gMain').src=src;
  document.getElementById('gBadge').textContent=label;
  var bs=document.querySelectorAll('#gThumbs button');
  for(var i=0;i<bs.length;i++)
    bs[i].setAttribute('aria-current', bs[i].querySelector('img').getAttribute('src')===src?'true':'false');
}

/* options */
function buildSwatches(){
  var w=document.getElementById('swatches'); w.innerHTML='';
  COLORS.forEach(function(c){
    var b=document.createElement('button');
    b.className='sw'; b.style.background=c.hex; b.title=c.name;
    b.setAttribute('aria-label',c.name);
    b.setAttribute('aria-pressed', c.name===state.color?'true':'false');
    b.onclick=function(){
      state.color=c.name;
      document.getElementById('colorName').textContent=c.name;
      document.getElementById('satcImg').src=c.img;
      showImg(c.img,c.name); buildSwatches(); render();
    };
    w.appendChild(b);
  });
}
function buildSizes(){
  var w=document.getElementById('sizes'); w.innerHTML='';
  SIZES.forEach(function(s){
    var b=document.createElement('button');
    b.className='sz'; b.textContent=s;
    b.setAttribute('aria-pressed', s===state.size?'true':'false');
    b.onclick=function(){ state.size=s; document.getElementById('sizeName').textContent=s;
      buildSizes(); render() };
    w.appendChild(b);
  });
}

/* bundle */
function buildBundle(){
  var b=document.getElementById('bundle'); b.innerHTML='';
  var RIB={2:'MOST POPULAR &mdash; <em>SAVE 45% + 2 FREE GIFTS</em>',
           3:'BEST VALUE &mdash; <em>SAVE 48% + 4 FREE GIFTS</em>'};
  [1,2,3].forEach(function(q){
    var t=TIERS[q], per=t.price/q, gifts=GIFTS.slice(0,t.gifts), ben=[];
    if(t.price>=FREE_SHIP) ben.push('Free shipping included');
    if(t.gifts) ben.push(t.gifts+' free cat gifts &mdash; $'+t.giftVal+' value');
    if(q===3) ben.push('Lowest price per hoodie');
    ben.push('30-day money-back guarantee');

    var h='';
    if(RIB[q]) h+='<span class="ribbon">'+RIB[q]+'</span>';
    h+='<span class="tinner"><span class="trow"><span class="radio"></span>'+
       '<span class="tmain"><span class="tname">'+
       (q===1?'One hoodie':q===2?'Two hoodies':'Three hoodies')+'</span>'+
       '<span class="tsub">'+money(per)+' each</span></span>'+
       '<span class="tprice"><span class="tnow">'+money(t.price)+'</span>'+
       '<span class="twas">'+money(t.was)+'</span></span></span>'+
       '<ul class="tben">'+ben.map(function(x){return '<li>'+x+'</li>'}).join('')+'</ul>';
    if(gifts.length){
      h+='<span class="gpanel"><span class="ghead">Your free gifts'+
         '<span class="gval">$'+t.giftVal+' value</span></span><span class="ggrid">'+
         gifts.map(function(g){
           return '<span class="gitem"><span class="gpill">FREE $'+g.v+'</span>'+
                  '<img src="'+g.i+'" alt="'+g.n+'" loading="lazy">'+
                  '<span class="gname">'+g.n+'</span></span>';
         }).join('')+'</span></span>';
    } else {
      h+='<span class="tnote">Add '+money(FREE_SHIP-t.price)+' more to unlock free shipping &amp; 2 free gifts</span>';
    }
    h+='</span>';

    var el=document.createElement('button');
    el.className='btier'; el.dataset.qty=q;
    el.setAttribute('aria-pressed', q===state.tier?'true':'false');
    el.innerHTML=h;
    el.onclick=function(){ setTier(q) };
    b.appendChild(el);
  });
}
function buildOffer(){
  var w=document.getElementById('ocards'); if(!w) return;
  w.innerHTML='';
  var HEAD={1:'STARTER',2:'MOST POPULAR',3:'BEST VALUE'};
  [1,2,3].forEach(function(q){
    var t=TIERS[q], per=t.price/q, gifts=GIFTS.slice(0,t.gifts);
    var d=document.createElement('div');
    d.className='ocard'+(q===3?' best':'');
    d.innerHTML='<div class="oh">'+HEAD[q]+'</div><div class="ob">'+
      '<div class="oq">'+q+' hoodie'+(q>1?'s':'')+'</div>'+
      '<div class="op">'+money(per)+'</div>'+
      '<div class="oe">each &middot; '+money(t.price)+' total</div>'+
      '<div class="ow">'+money(t.was)+'</div>'+
      (gifts.length
        ? '<div class="og">'+gifts.map(function(g){return '<img src="'+g.i+'" alt="'+g.n+'" loading="lazy">'}).join('')+'</div>'+
          '<div class="ogl">+ '+t.gifts+' free gifts ($'+t.giftVal+' value)</div>'
        : '<div class="oe" style="margin-top:8px">No free gifts at this tier</div>')+
      '<button class="obtn">'+(q===state.tier?'Selected':'Choose this')+'</button></div>';
    d.querySelector('.obtn').onclick=function(){
      setTier(q); buildOffer();
      document.querySelector('.cta-1').scrollIntoView({behavior:'smooth',block:'center'});
    };
    w.appendChild(d);
  });
}
function setTier(q){
  state.tier=q;
  document.querySelectorAll('.btier').forEach(function(t){
    t.setAttribute('aria-pressed', Number(t.dataset.qty)===q?'true':'false');
  });
  render(); buildOffer();
}
function toggleBump(){
  state.ship=!state.ship;
  document.getElementById('bumpShip').setAttribute('aria-pressed', state.ship?'true':'false');
  render();
}

/* totals */
function total(){ return TIERS[state.tier].price + (state.ship?SHIP_PROT:0) }
function render(){
  var t=TIERS[state.tier], tot=total(), per=t.price/state.tier;
  var was=t.was+(state.ship?SHIP_PROT:0)+t.giftVal;
  var pct=Math.round((UNIT_RRP-per)/UNIT_RRP*100);
  document.getElementById('pNow').innerHTML=money(per)+'<span class="peach">each</span>';
  document.getElementById('pWas').textContent=money(UNIT_RRP);
  document.getElementById('pBadge').textContent='SAVE '+pct+'%';
  document.getElementById('gSave').textContent='SAVE '+pct+'%';
  document.getElementById('pUnit').innerHTML=state.tier+' hoodie'+(state.tier>1?'s':'')+
    ' &mdash; <b>'+money(t.price)+'</b> total'+(t.gifts?' &middot; <b>'+t.gifts+' free gifts</b>':'');
  document.getElementById('ctaPrice').textContent=money(tot);
  document.getElementById('satcPrice').textContent=money(tot);
  document.getElementById('satcSub').textContent=
    state.color+' · '+state.size+' · '+state.tier+' hoodie'+(state.tier>1?'s':'');
  var n=28+(state.color.length*3)+(SIZES.indexOf(state.size)*5);
  document.getElementById('stockTxt').textContent='Only '+n+' left in '+state.color+' / '+state.size;
  document.getElementById('stockBar').style.width=Math.max(12,Math.min(38,n/2))+'%';
  document.getElementById('shipHead').textContent = tot>=FREE_SHIP
    ? 'Free tracked shipping — this order qualifies'
    : 'Add '+money(FREE_SHIP-tot)+' more for free shipping';
}

/* cart */
function addToCart(){
  var per=TIERS[state.tier].price/state.tier;
  var col=COLORS.filter(function(x){return x.name===state.color})[0]||COLORS[0];
  for(var i=0;i<state.tier;i++)
    state.cart.push({t:'h',name:'The Mewpouch Original',v:state.color+' / '+state.size,p:per,img:col.img});
  GIFTS.slice(0,TIERS[state.tier].gifts).forEach(function(g){
    state.cart.push({t:'g',name:g.n,v:'Free gift',p:0,was:g.v,img:TIERS[state.tier].img});
  });
  if(state.ship && !state.cart.some(function(l){return l.t==='s'}))
    state.cart.push({t:'s',name:'Shipping protection',v:'Reship guarantee',p:SHIP_PROT,img:MPASSET["mp-detail.png"]});
  drawCart(); openCart();
  toast(TIERS[state.tier].gifts?('Added — '+TIERS[state.tier].gifts+' free gifts included'):'Added to cart');
}
function buyNow(){ addToCart(); setTimeout(function(){ toast('Checkout is disabled in this preview') },800) }
function drawCart(){
  var b=document.getElementById('dBody'); b.innerHTML='';
  if(!state.cart.length) b.innerHTML='<div class="dempty">Your cart is empty.</div>';
  else state.cart.forEach(function(l,i){
    var d=document.createElement('div'); d.className='li';
    d.innerHTML='<img src="'+l.img+'" alt=""><div class="lx"><div class="lt">'+l.name+'</div>'+
      '<div class="lv">'+l.v+'</div><div class="lp'+(l.p===0?' free':'')+'">'+(l.p===0?'FREE':money(l.p))+
      (l.was?' <span style="color:var(--muted);text-decoration:line-through;font-weight:600">$'+l.was+'</span>':'')+'</div></div>';
    if(l.t!=='g'){
      var rm=document.createElement('button'); rm.className='rm'; rm.textContent='Remove';
      rm.onclick=function(){ state.cart.splice(i,1); drawCart() };
      d.appendChild(rm);
    }
    b.appendChild(d);
  });
  var sub=state.cart.reduce(function(a,l){return a+l.p},0);
  document.getElementById('dSub').textContent=money(sub);
  document.getElementById('cartCount').textContent=state.cart.length;
  var hood=state.cart.filter(function(l){return l.t==='h'});
  var saved=hood.length*99.90-hood.reduce(function(a,l){return a+l.p},0)
    +state.cart.filter(function(l){return l.t==='g'}).reduce(function(a,l){return a+(l.was||0)},0);
  var sv=document.getElementById('dSave');
  if(saved>0.01){ sv.style.display='flex'; document.getElementById('dSaveAmt').textContent='−'+money(saved) }
  else sv.style.display='none';
  document.getElementById('sFill').style.width=Math.min(100,sub/FREE_SHIP*100)+'%';
  document.getElementById('shipTxt').innerHTML= sub>=FREE_SHIP
    ? '<b>Free shipping unlocked</b>' : 'Add <b>'+money(FREE_SHIP-sub)+'</b> for free shipping';
}
function openCart(){document.getElementById('drw').classList.add('on');document.getElementById('ovl').classList.add('on')}
function closeCart(){document.getElementById('drw').classList.remove('on');document.getElementById('ovl').classList.remove('on')}

/* reviews */
var REVIEWS=[
 {i:MPASSET["mp-u3.png"],s:5,t:"She found it before I did",q:"Left it on the bed and came back to her already asleep in the pouch. Hasn't got out since.",n:"Margaret H.",m:"Grey · L"},
 {i:MPASSET["mp-u1.png"],s:5,t:"Deeper than I expected",q:"Holds its shape with an 11 lb cat in it. Washed twice on cold, no pilling.",n:"Emma R.",m:"Beige · M"},
 {i:MPASSET["mp-u2.png"],s:5,t:"Unboxing was a whole event",q:"My cat sat in the empty box while I unfolded it. Fabric is much thicker than the photos suggest.",n:"Priya N.",m:"Pink · S"},
 {i:MPASSET["mp-u5.png"],s:5,t:"Our new evening routine",q:"Kitten goes in around 8pm and stays there till I get up. I've stopped using the sofa blanket entirely.",n:"Jess T.",m:"Coffee · M"},
 {i:MPASSET["mp-u6.png"],s:5,t:"Bought it for my wife, stole it",q:"Ordered as a gift and now I wear it at my desk. The orange one supervises.",n:"Daniel K.",m:"Grey · XL"},
 {i:MPASSET["mp-u4.png"],s:5,t:"Genuinely warm",q:"Kitchen is freezing in the mornings and this plus a coffee is enough. Cat optional but she insists.",n:"Aisha M.",m:"Black · M"},
 {i:MPASSET["mp-u9.png"],s:4,t:"Great, but size up",q:"Took my usual M and it fits, but I wanted it slouchier. Going L next time. Cat took a week to commit.",n:"Yuki S.",m:"Pink · M"},
 {i:MPASSET["mp-u7.png"],s:5,t:"Works for small dogs too",q:"My Pom is 9 lb and fits fine. Bought it for the cat, the dog claimed it. Such is life.",n:"Hannah B.",m:"Khaki · L"},
 {i:MPASSET["mp-u8.png"],s:5,t:"Arrived in four days",q:"Quicker than expected and packaged properly. The pouch holds its own shape on a flat surface.",n:"Robin C.",m:"Beige · 2XL"},
 {i:MPASSET["mp-u10.png"],s:5,t:"Balcony cat approves",q:"We sit out most evenings now. He can see over the rail and I'm not holding him the whole time.",n:"Lena V.",m:"Black · L"},
 {i:MPASSET["mp-d3.png"],s:5,t:"My Yorkie lives in it",q:"Bought it half expecting him to hate it. He now sits by the hoodie waiting for me to put it on. 7 lb and loads of room.",n:"Tom A.",m:"Grey · XL"},
 {i:MPASSET["mp-d4.png"],s:5,t:"Perfect for a sausage dog",q:"Dachshunds hate being cold and hate being put down. This solves both. The pouch supports his back properly.",n:"Marie O.",m:"Black · M"}
];
(function(){
  var w=document.getElementById('rwall');
  REVIEWS.forEach(function(r){
    var d=document.createElement('div'); d.className='rev';
    d.innerHTML='<div class="rimg"><img src="'+r.i+'" alt="Customer photo from '+r.n+'" loading="lazy">'+
      '<span class="qb">&rdquo;</span></div>'+
      '<div class="rb"><div class="rstars">'+'★'.repeat(r.s)+'<span style="opacity:.22">'+'★'.repeat(5-r.s)+'</span></div>'+
      '<div class="rt">'+r.t+'</div><q>'+r.q+'</q>'+
      '<div class="rau"><img src="'+r.i+'" alt="" loading="lazy">'+
      '<span class="an">'+r.n+'</span><span class="av">&#10003; Verified</span></div></div>';
    w.appendChild(d);
  });
})();

/* faq */
var FAQS=[
 ["What size pet fits?","The pouch is 11&Prime; deep by 9&Prime; wide, <b>rated to 12 lb</b>. That covers most adult cats, kittens, and small dogs up to roughly a Pomeranian or Yorkie. Above 12 lb it still holds, but the weight pulls on your shoulders."],
 ["Is it safe for my cat?","It's a <b>resting pouch for around the house, not a carrier</b>. The top stays open so they can leave whenever they want, and the fabric breathes. Support it with a hand when you stand. Don't use it for car journeys or vet trips, and never leave a pet in it unsupervised."],
 ["What if my cat hates it?","Some get in within a minute, some need a week and a treat placed inside. If yours says no, <b>return it within 30 days for a full refund</b> — worn or washed. You keep the gifts."],
 ["How does it wash?","Machine wash cold on gentle, tumble low or air-dry. <b>Skip fabric softener</b> — it flattens sherpa pile. Expect light shedding on the first wash only."],
 ["When will it arrive?","Ships in 1–2 business days, then 5–8 business days in transit within the continental US. Tracking sent as soon as the label is made."],
 ["What are the free gifts?","Buy 2 and you get the <b>Catnip Kicker Fish</b> and <b>Feather Teaser Wand</b>. Buy 3 and you also get the <b>Silicone Grooming Glove</b> and a <b>Crinkle Ball 4-Pack</b>. They ship in the same parcel."]
];
(function(){
  var w=document.getElementById('faqList');
  FAQS.forEach(function(f,i){
    var d=document.createElement('div'); d.className='q'; d.setAttribute('data-open', i===0?'1':'0');
    d.innerHTML='<button>'+f[0]+'<span class="pl"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></span></button><div class="a">'+f[1]+'</div>';
    d.querySelector('button').onclick=function(){ d.setAttribute('data-open', d.getAttribute('data-open')==='1'?'0':'1') };
    w.appendChild(d);
  });
})();

/* popup */
function openPop(){ if(state.popDone) return; state.popDone=true; document.getElementById('pop').classList.add('on') }
function closePop(){ document.getElementById('pop').classList.remove('on') }
function submitPop(e){ e.preventDefault(); closePop(); toast('Code sent — check your inbox') }
setTimeout(openPop, 32000);
window.addEventListener('scroll', function(){
  if(window.scrollY > document.body.scrollHeight*0.45) openPop();
}, {passive:true});

var tT;
function toast(m){ var t=document.getElementById('toast'); t.textContent=m; t.classList.add('on');
  clearTimeout(tT); tT=setTimeout(function(){t.classList.remove('on')},2400) }

/* dates + real dispatch cutoff */
(function(){
  var f=function(d){return d.toLocaleDateString('en-US',{month:'short',day:'numeric'})};
  var biz=function(d,n){var x=new Date(d),c=0;while(c<n){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)c++}return x};
  var t=new Date();
  document.getElementById('d1').textContent=f(t);
  document.getElementById('d2').textContent=f(biz(t,1))+'–'+f(biz(t,2));
  document.getElementById('d3').textContent=f(biz(t,7))+'–'+f(biz(t,10));
  function tick(){
    var now=new Date(), cut=new Date(now); cut.setHours(15,0,0,0);
    var el=document.getElementById('cutoff');
    if(now>=cut){ el.innerHTML='Ordered after 3pm — <b>dispatches next business day</b>'; return }
    var ms=cut-now, h=Math.floor(ms/3.6e6), m=Math.floor(ms%3.6e6/6e4), s=Math.floor(ms%6e4/1000);
    el.innerHTML='Order within <b>'+h+'h '+m+'m '+s+'s</b> for dispatch today';
  }
  tick(); setInterval(tick,1000);
})();

(function(){
  var it=document.querySelectorAll('.ann-i'), i=0;
  setInterval(function(){ it[i].classList.remove('on'); i=(i+1)%it.length; it[i].classList.add('on') },4200);
})();

(function(){
  var a=document.querySelector('.cta-1'), bar=document.getElementById('satc');
  new IntersectionObserver(function(es){
    es.forEach(function(e){ bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top<0) });
  },{threshold:0}).observe(a);
})();

buildThumbs(); buildSwatches(); buildSizes(); buildBundle(); buildOffer(); render(); drawCart();
document.addEventListener('keydown',function(e){ if(e.key==='Escape'){closeCart();closePop()} });